import React, { useState } from 'react';
import { QuestionSingleResponseMessage } from '../../../domain/richMessage.interface';
import { TextCard } from './TextCard';

interface QuestionSingleResponseCardProps {
  data: QuestionSingleResponseMessage;
  onSelect: (labels: string[]) => void;
}

export const QuestionSingleResponseCard: React.FC<QuestionSingleResponseCardProps> = ({ data, onSelect }) => {
  const storageKey = `questionSingleResponse_${data.options.map((o) => o.id).join('_')}`;

  const [selectedId, setSelectedId] = useState<string | null>(() =>
    localStorage.getItem(storageKey)
  );

  const handleSelect = (id: string, label: string) => {
    if (selectedId) return;
    setSelectedId(id);
    localStorage.setItem(storageKey, id);
    onSelect([label]);
  };

  return (
    <div>
      <TextCard message={data.text} />
      <div className="flex flex-col gap-2 mt-2">
        {data.options.map((option) => (
          <button
            key={option.id}
            onClick={() => handleSelect(option.id, option.label)}
            className={`text-left border rounded-xl p-3 transition-colors w-full ${
              selectedId
                ? selectedId === option.id
                  ? 'border-coral pointer-events-none'
                  : 'border-black/[0.12] opacity-40 pointer-events-none'
                : 'border-black/[0.12] hover:border-navy/20'
            }`}
          >
            <p className="text-navy font-bold text-sm">{option.label}</p>
          </button>
        ))}
      </div>
    </div>
  );
};
